import { VisitorFieldEnum } from 'constants-visitor-management';

import { visitorManagementFeatureDefinition } from '../featureDefinition/VisitorManagement';

/**
 * Consumers must ensure these interaction types are registered in the property
 * type system: 'VisitorType', 'ScheduleType', 'HostInformationType', 'NotesType'.
 * They are defined in application-types (e.g. ScheduleTypeDefinition, HostInformationTypeDefinition).
 */

export function isRequired(property: string) {
  return property === VisitorFieldEnum.Required;
}

export function isOptional(property: string) {
  return property === VisitorFieldEnum.Optional;
}

export function isHidden(property: string) {
  return property === VisitorFieldEnum.Hide;
}

/** Single source of truth: re-exported from featureDefinition/VisitorManagement/definitions.ts */
export { visitorManagementFeatureDefinition };
export default visitorManagementFeatureDefinition;
